module.exports = __webpack_public_path__ + "static/media/comdlg32_534.58d52b36.ico";